// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__IXb8k","navItem":"nav_navItem__7N6IV","navItemImage":"nav_navItemImage__8D-1S","navItemTitle":"nav_navItemTitle__KqfC6"};